export default __webpack_public_path__ + "static/main_scr-268bbd6843a2129c2b8f7e452156d8d1.png";